<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="name">
                <span slot="label" ><a-tooltip>{{$t('商户名称 ')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+'进件的二级商户名称 '" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="aliasName">
                  <span slot="label" ><a-tooltip>{{$t('商户别名')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.aliasName" :maxLength="32" :placeholder="$t('请输入')+'商户别名'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="legalName">
                  <span slot="label" ><a-tooltip>{{$t('法人名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.legalName" :maxLength="32" :placeholder="$t('请输入')+'法人名称'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="legalCertNo">
                  <span slot="label" ><a-tooltip>{{$t('法人身份证号')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.legalCertNo" :maxLength="32" :placeholder="$t('请输入')+'法人身份证号'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="contactName">
                  <span slot="label" ><a-tooltip>{{$t('联系人名字')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.contactName" :maxLength="32" :placeholder="$t('请输入')+'联系人名字'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="contactMobile">
                  <span slot="label" ><a-tooltip>{{$t('联系人手机号')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.contactMobile" :maxLength="32" :placeholder="$t('请输入')+'联系人手机号'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="contactIdCardNo">
                  <span slot="label" ><a-tooltip>{{$t('联系人身份证号')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.contactIdCardNo" :maxLength="32" :placeholder="$t('请输入')+'联系人身份证号'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['merchant:extraapplyalipay:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:extraapplyalipay:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :merchantId="merchantId"
        :merchantType="merchantType"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="certImage" slot-scope="text, record">
          <div>
            <img v-if="record.certImage" :src="record.certImage" style="width:50px;height:50px;" @click="handleRecordPreview(record.certImage)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-button type="link" size="small" @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:extraapplyalipay:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button type="link" size="small" @click="handleAlipayApply(record)" style="color: #f30202"  v-if="!record.smid">
            <a-icon type="edit" />进件
          </a-button>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageExtraApplyAlipay,applyExtraApplyAlipay, delExtraApplyAlipay } from '@/api/merchant/extraApplyAlipay';
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ExtraApplyAlipay',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantId: undefined,
      merchantType: undefined,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantType: undefined,
        name: undefined,
        aliasName: undefined,
        mcc: undefined,
        service: undefined,
        certNo: undefined,
        certName: undefined,
        certType: undefined,
        certImage: undefined,
        certImageBack: undefined,
        legalName: undefined,
        legalCertType: undefined,
        legalCertNo: undefined,
        legalCertFrontImage: undefined,
        legalCertBackImage: undefined,
        address: undefined,
        defaultSettleType: undefined,
        accountHolderName: undefined,
        accountNo: undefined,
        accountInstProvince: undefined,
        accountInstCity: undefined,
        accountBranchName: undefined,
        usageType: undefined,
        accountType: undefined,
        accountInstName: undefined,
        accountInstId: undefined,
        bankCode: undefined,
        inDoorImages: undefined,
        outDoorImages: undefined,
        alipayLogonId: undefined,
        bindingAlipayLogonId: undefined,
        servicePhone: undefined,
        contactName: undefined,
        contactMobile: undefined,
        contactIdCardNo: undefined,
        qualifications: undefined,
        licenseAuthLetterImage: undefined,
        sites: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商户名称 '),
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: this.$t('商户证件编号'),
          dataIndex: 'certNo',
          align: 'center'
        },
        {
          title: this.$t('商户证件图'),
          dataIndex: 'certImage',
          scopedSlots: { customRender: 'certImage' },
          align: 'center'
        },
        {
          title: this.$t('法人名称'),
          dataIndex: 'legalName',
          align: 'center'
        },
        {
          title: this.$t('地址'),
          dataIndex: 'address',
          align: 'center'
        },
        {
          title: this.$t('默认结算类型'),
          dataIndex: 'defaultSettleType',
          align: 'center'
        },
        {
          title: this.$t('联系人名字'),
          dataIndex: 'contactName',
          align: 'center'
        },
        {
          title: this.$t('联系人手机号'),
          dataIndex: 'contactMobile',
          align: 'center'
        },
        {
          title: this.$t('联系人身份证号'),
          dataIndex: 'contactIdCardNo',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.pushMerchantId()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商家进件-支付宝直付通列表 */
    getList () {
      this.loading = true
      pageExtraApplyAlipay(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    pushMerchantId() {
      let merchantId = this.$route.query.merchantId;
      if (merchantId) {
        this.merchantId = merchantId;
        this.merchantType = Number(this.$route.query.merchantType);
      }
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantType: undefined,
        name: undefined,
        aliasName: undefined,
        mcc: undefined,
        service: undefined,
        certNo: undefined,
        certName: undefined,
        certType: undefined,
        certImage: undefined,
        certImageBack: undefined,
        legalName: undefined,
        legalCertType: undefined,
        legalCertNo: undefined,
        legalCertFrontImage: undefined,
        legalCertBackImage: undefined,
        address: undefined,
        defaultSettleType: undefined,
        accountHolderName: undefined,
        accountNo: undefined,
        accountInstProvince: undefined,
        accountInstCity: undefined,
        accountBranchName: undefined,
        usageType: undefined,
        accountType: undefined,
        accountInstName: undefined,
        accountInstId: undefined,
        bankCode: undefined,
        inDoorImages: undefined,
        outDoorImages: undefined,
        alipayLogonId: undefined,
        bindingAlipayLogonId: undefined,
        servicePhone: undefined,
        contactName: undefined,
        contactMobile: undefined,
        contactIdCardNo: undefined,
        qualifications: undefined,
        licenseAuthLetterImage: undefined,
        sites: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleAdd() {
      //查询有没有进件记录
      this.$refs.createForm.handleAdd(this.merchantId, this.total);
    },
    handleAlipayApply(record) {
      this.loading = true
      applyExtraApplyAlipay({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件成功待审核",3)
          this.getList()
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delExtraApplyAlipay(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/merchant/extra/apply/alipay/export',
            that.queryParam
            , `商家进件-支付宝直付通_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>